var exports = {
  "k": "x234b8571--c5cb7e--container",
};

module.exports = exports;
